import React, { useContext, useEffect, useState } from "react"
import { ajvResolver } from "@hookform/resolvers/ajv"
import { Alert, CircularProgress, Card, Box, ModalClose, Tabs, TabList, Tab, TabPanel } from "@mui/joy"
import { fullFormats } from "ajv-formats/dist/formats"
import { useForm, useWatch, FormProvider } from "react-hook-form"
import { CardActionArea, Backdrop } from "@mui/material"
import { BreadCrumb, Button, DetailTitle, ImportData, Input, InputCompare, Tag, Text } from "..";
import { useTranslation } from 'react-i18next';
import { useFormVisibilityHandler } from "../../utils";
import { useFieldReadonlyHandler } from "../../utils";
import { useFieldWatcher } from "./detail.hooks"
import { AppContext } from "src/mtska-frontend-app-scaffolding"

const DetailCompare = ({ editingDefault = false, detailStack, filters, detailConfig, modelName, readonly = false, values, onEditing = () => { }, save = () => { }, saving, errors, errorMessage, alertMessage, isDrawer, isEmbedded, rightButtons, title, subtitle = "", header, label, canSave, icon = "" }) => {

    const { t } = useTranslation();
    const { verifyCondition } = useFormVisibilityHandler();
    const { verifyCondition: verifyReadonlyCondition } = useFieldReadonlyHandler();

    // EDITING
    const [editing, setEditing] = useState(editingDefault);

    const activateEditing = () => {
        if (readonly) return;
        onEditing(true);
        setEditing(true)
    }

    const [formValues, setFormValues] = useState({});

    useEffect(() => {

        if (typeof values !== 'object') {
            return;
        }

        //#####################################################
        const newValues = { ...values };
        typeof detailConfig?.tabs === 'object' && Object.entries(detailConfig.tabs).map(([k, tab]) => {
            typeof tab?.fieldsets === 'object' && Object.entries(tab.fieldsets).map(([k, fieldset]) => {
                typeof fieldset?.fields === 'object' && Object.entries(fieldset.fields).map(([k, field]) => {
                    // console.log("FIELD", k, field);
                    if (typeof detailStack?.inverseRelation?.[k] !== 'undefined') {
                        // we have inverseRealtion value
                        //console.log("detailStack.inverseRelation", detailStack?.inverseRelationType, k, detailStack?.inverseRelation[k], values[k]);
                        if (detailStack?.inverseRelationType === 'relationship') {
                            //console.log("detailStack.inverseRelation setto relationship", detailStack?.inverseRelationType, k, detailStack?.inverseRelation[k], values[k]);
                            if (Array.isArray(values[k]) && !values[k].some(e => e._id === detailStack?.inverseRelation[k]._id)) {
                                //console.log("detailStack.SET stack 1", detailStack?.inverseRelationType, values[k]);
                                newValues[k] = [...values[k], detailStack?.inverseRelation[k]];
                            }
                            if (!Array.isArray(values[k])) {
                                //console.log("detailStack.SET stack 2", detailStack?.inverseRelationType, values[k]);
                                newValues[k] = [detailStack?.inverseRelation[k]];
                            }

                        }
                        if (detailStack?.inverseRelationType === 'relationshipSingle' && typeof values[k] === 'undefined') {
                            //console.log("detailStack.inverseRelation setto relationshipSingle", detailStack?.inverseRelationType, k, detailStack?.inverseRelation[k], values[k]);
                            newValues[k] = detailStack?.inverseRelation[k];
                        }
                    }
                })
            })
        })

        //####################################################
        setFormValues(newValues);
        // setFormValues({ ...values });
    }, [values, detailConfig])

    // FORM 
    const { handleSubmit, control, setError, setValue, formState, getValues, resetField, getFieldState, watch } = useForm({
        values: formValues,
        resolver: ajvResolver(detailConfig?.validation ?? [], { formats: fullFormats, }),
    })

    const watchedFields = useWatch({ control })
    useFieldWatcher({ setValue, watchedFields, editing })

    useEffect(() => {
        if (typeof errors !== 'object') return;
        Object.entries(errors).map(
            ([k, v], i) => setError(k, { type: 'server', message: v[0] })
        )
    }, [errors])

    const localHandleSubmit = (data) => {
        save(data);
    }

    const { userCapabilities } = useContext(AppContext);
    const getDrawerClassName = () => {
        let cn = ['drawer-section-content'];

        cn.push(userCapabilities['auth/role.is_driver'] ? 'driver' : '');
        cn.push(userCapabilities['auth/role.is_carmanager'] ? 'carmanager' : '');
        cn.push(userCapabilities['auth/role.is_fleetmanager'] ? 'fleetmanager' : '');
        cn.push(userCapabilities['auth/role.is_superuser'] ? 'superuser' : '');

        cn.filter((cne) => cne !== '');

        return cn.join(' ');
    }

    return (
        <>
            {isDrawer && (
                <>
                    <Box className="drawer-section-header" >
                        <ModalClose />
                        <DetailTitle title={title} subtitle={subtitle} icon={icon} />

                        <Box display={"flex"} flexDirection="row"
                            justifyContent={"end"}
                            gap={1}
                            flexGrow={1}>
                            {Array.isArray(rightButtons) && rightButtons.map((v, k) =>
                                <div key={k}>{v}</div>
                            )}
                            <Button
                                label={t("Save")}
                                onClick={canSave && handleSubmit(localHandleSubmit)}
                                disabled={!canSave}
                            />
                        </Box>
                    </Box>

                    <BreadCrumb />
                </>
            )}
            {errorMessage && (
                <Alert color="danger">{errorMessage}</Alert>
            )}
            <Box className={getDrawerClassName() + (isEmbedded ? ' drawer-section-content-embedded form-element col-12' : '')}>
                {header}
                <Backdrop open={saving} style={{ backgroundColor: "white" }}>
                    <CircularProgress />
                </Backdrop>
                <Card className="form-wrapper">



                    <FormProvider handleSubmit={handleSubmit} control={control} setError={setError} setValue={setValue} formState={formState} getValues={getValues} resetField={resetField} getFieldState={getFieldState} watch={watch}>
                        <ActionArea readonly={readonly} focusVisibleClassName="none" disableRipple={editing} disableTouchRipple={editing} onClick={activateEditing}  >

                            {alertMessage && (
                                <Tag color="danger" size="medium" icon="faWarning">{alertMessage}</Tag>
                            )}
                            {typeof detailConfig?.tabs === 'object' && (

                                <Tabs aria-label="Basic tabs" defaultValue={0} className="mtska-tabs" >
                                    {Object.entries(detailConfig.tabs).length > 1 && (
                                        <Box className="mtska-tab-list-scroller">
                                            <TabList className="mtska-tab-list">
                                                {Object.entries(detailConfig.tabs).map(([k, tab]) => {
                                                    let visible = verifyCondition(tab, watch);

                                                    return (visible ?
                                                        <Tab key={k} className="mtska-tab" data-type="tab" data-name={tab.name}>
                                                            {t(tab.name)}
                                                        </Tab>
                                                        :
                                                        // Dobbiamo comunque disegnarlo perché altrimenti saltano i riferimenti tra tab e panel
                                                        <Tab key={k} className="mtska-tab mtska-tab-hidden" data-type="tab" data-name={tab.name}>
                                                            {t(tab.name)} NASCOSTO
                                                        </Tab>
                                                    )
                                                })}
                                            </TabList>
                                        </Box>
                                    )}
                                    {Object.entries(detailConfig.tabs).map(([k, tab]) => {
                                        let visible = verifyCondition(tab, watch);

                                        return (visible ?

                                            <TabPanel className="mtska-tab-panel" value={parseInt(k)} key={k} data-type="tabpanel" data-name={tab.name}>
                                                {
                                                    Object.entries(tab.fieldsets).map(([k, fieldset]) => {

                                                        let visible = verifyCondition(fieldset, watch);

                                                        return (visible &&
                                                            <fieldset className="mtska-fieldset " data-type="fieldset" data-name={fieldset.name}>
                                                                {Object.entries(tab.fieldsets).length > 1 && (
                                                                    <Text level="title-md" className={"mtska-fieldset-title form-element fullwidth"}>{t(fieldset.name)}</Text>
                                                                )}
                                                                <table width={"100%"}>
                                                                    <thead>
                                                                        <td width={"33%"}>
                                                                            In
                                                                        </td>
                                                                        {(values.similars ?? []).map((item, index) => (
                                                                            <td key={index} width={"33%"}>
                                                                                Db
                                                                            </td>
                                                                        ))}
                                                                        <td width={"33%"}>&nbsp;</td>
                                                                    </thead>
                                                                    {
                                                                        Object.entries(fieldset.fields).map(([k, field]) => {
                                                                            let visible = verifyCondition(field, watch);
                                                                            if (typeof field === 'object' && field !== null && field.readonlycondition) {
                                                                                field.readonly = verifyReadonlyCondition(field, watch);
                                                                            }
                                                                            return (visible &&
                                                                                <InputCompare
                                                                                    handleSubmit={handleSubmit(localHandleSubmit)}
                                                                                    editing={editing}
                                                                                    control={control}
                                                                                    key={k}
                                                                                    name={k}
                                                                                    label={k}
                                                                                    item={formValues}
                                                                                    detailStack={detailStack}
                                                                                    modelName={modelName}
                                                                                    setValue={setValue}
                                                                                    {...field} />
                                                                            )
                                                                        })
                                                                    }
                                                                </table>
                                                            </fieldset>
                                                        )
                                                    })
                                                }
                                            </TabPanel>
                                            :
                                            // Dobbiamo comunque disegnarlo perché altrimenti saltano i riferimenti tra tab e panel
                                            <TabPanel className="mtska-tab-panel" value={parseInt(k)} key={k} data-name={tab.name}>
                                                {tab.name}
                                            </TabPanel>
                                        )
                                    })}
                                </Tabs>
                            )}

                        </ActionArea>
                    </FormProvider>
                </Card>

                {
                    values?.data_ids && values?.data_ids.map((data_id) => <ImportData importdataid={data_id} />)
                }

            </Box>
        </>

    )
}

const ActionArea = ({ readonly, children, focusVisibleClassName, disableRipple, disableTouchRipple, onClick }) => {

    //if (readonly) return <div >{children}</div>

    return <>
        <CardActionArea
            className="form-section-fields-wrapper"
            focusVisibleClassName={focusVisibleClassName}
            disableRipple={disableRipple}
            disableTouchRipple={disableTouchRipple}
            onClick={onClick} >{children}</CardActionArea>
    </>
}

export default DetailCompare;